var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPromocionales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4335",
    "data-name": "Group 4335",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.723,
    height: 26.723,
    viewBox: "0 0 26.723 26.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002e6b;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3651",
    "data-name": "Rectangle 3651",
    className: "cls-1",
    width: 26.723,
    height: 26.723
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7492",
    "data-name": "Path 7492",
    className: "cls-1",
    d: "M22.3,29.14V16.909L32.89,23.025Zm1.458-9.707v7.183l6.22-3.591Z",
    transform: "translate(-12.743 -9.663)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4314",
    "data-name": "Group 4314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4313",
    "data-name": "Group 4313",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7493",
    "data-name": "Path 7493",
    className: "cls-1",
    d: "M13.361,1.458a11.9,11.9,0,1,1-11.9,11.9,11.917,11.917,0,0,1,11.9-11.9m0-1.458A13.361,13.361,0,1,0,26.723,13.361,13.361,13.361,0,0,0,13.361,0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPromocionales);
export default __webpack_public_path__ + "static/media/Icon_promocionales.7acfb14398da047018c6cc6014485793.svg";
export { ForwardRef as ReactComponent };